module.exports = __webpack_public_path__ + "img/on-recrute.9a0d7d5a.png";